import type { ActionNotice, AsyncOperationEvent, TransmissionNotice } from '@core/databus/IMessage'
import { NoticeCategory, Notice } from '@core/databus/IMessage'
import type { INoticeListener, INoticeResult } from '@core/databus/IDataSyncManager'
import type { ActionNoticeData, AsyncOperationEventData, TransmissionNoticeData } from '@core/databus/DataSyncManager'
import { INSTANCE as dataSyncManager, NoticeData } from '@core/databus/DataSyncManager'

interface IDataBus<T, U> {
  get webClientId(): string

  appendNotice(notice: T): Promise<INoticeResult<U>>

  removeNotice(id: string): Promise<INoticeResult<boolean>>

  updateNoticeById(id: string, data: Partial<T>): Promise<INoticeResult<U>>

  // getNoticeById(id: string): Promise<INoticeResult<U>>

  // getAllNotices(): Promise<INoticeResult<U[]>>

  addNoticeListener(listener: INoticeListener<U>): void

  removeNoticeListener(listener: INoticeListener<U>): boolean

  removeNoticesByIds(ids: string[]): Promise<INoticeResult<boolean>>

  // removeAllNotice(): Promise<INoticeResult<boolean>>
}

export class ActionNoticeDataBus implements IDataBus<ActionNotice, ActionNoticeData> {
  get webClientId() {
    return dataSyncManager.webClientId
  }

  async appendNotice(notice: ActionNotice): Promise<INoticeResult<ActionNoticeData>> {
    return dataSyncManager.appendActionNotice(notice)
  }

  async removeNotice(id: string): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticeById(id)
  }

  async updateNoticeById(id: string, data: Partial<ActionNotice>): Promise<INoticeResult<ActionNoticeData>> {
    return dataSyncManager.updateNoticeById<ActionNoticeData>(id, data)
  }

  // async getNoticeById(id: string): Promise<INoticeResult<ActionNoticeData>> {
  //   return dataSyncManager.getNoticeById(id)
  // }

  async getAllNotices(): Promise<INoticeResult<ActionNoticeData[]>> {
    return dataSyncManager.getAllNoticesByCategory<ActionNoticeData>(NoticeCategory.NOTICE)
  }

  addNoticeListener(listener: INoticeListener<ActionNoticeData>) {
    dataSyncManager.addNoticeListener(NoticeCategory.NOTICE, listener)
  }

  removeNoticeListener(listener: INoticeListener<ActionNoticeData>): boolean {
    return dataSyncManager.removeNoticeListener(NoticeCategory.NOTICE, listener)
  }

  async removeNoticesByIds(ids: string[]): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticesByIds(ids)
  }

  /* 全部清除 */
  // async removeAllNotice(): Promise<INoticeResult<boolean>> {
  //   return dataSyncManager.removeNoticeByCategory<ActionNoticeData>(NoticeCategory.NOTICE)
  // }
}

export class TransmissionDataBus implements IDataBus<TransmissionNotice, TransmissionNoticeData> {
  get webClientId() {
    return dataSyncManager.webClientId
  }

  async appendNotice(notice: TransmissionNotice): Promise<INoticeResult<TransmissionNoticeData>> {
    return dataSyncManager.appendTransmissionNotice(notice)
  }

  async removeNotice(id: string): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticeById(id)
  }

  async updateNoticeById(
    id: string,
    data: Partial<TransmissionNotice>
  ): Promise<INoticeResult<TransmissionNoticeData>> {
    return dataSyncManager.updateNoticeById<TransmissionNoticeData>(id, data)
  }

  async getNoticeById(id: string): Promise<INoticeResult<TransmissionNoticeData>> {
    return dataSyncManager.getNoticeById(id)
  }

  // async getAllNotices(): Promise<INoticeResult<TransmissionNoticeData[]>> {
  //   return dataSyncManager.getAllNoticesByCategory<TransmissionNoticeData>(NoticeCategory.TRANSMISSION)
  // }

  addNoticeListener(listener: INoticeListener<TransmissionNoticeData>) {
    dataSyncManager.addNoticeListener(NoticeCategory.TRANSMISSION, listener)
  }

  removeNoticeListener(listener: INoticeListener<TransmissionNoticeData>): boolean {
    return dataSyncManager.removeNoticeListener(NoticeCategory.TRANSMISSION, listener)
  }

  async removeNoticesByIds(ids: string[]): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticesByIds(ids)
  }

  // async removeAllNotice(): Promise<INoticeResult<boolean>> {
  //   return dataSyncManager.removeNoticeByCategory<TransmissionNoticeData>(NoticeCategory.TRANSMISSION)
  // }
}

export class AsyncOperationEventDataBus implements IDataBus<AsyncOperationEvent, AsyncOperationEventData> {
  appendNoticeData: any
  get webClientId() {
    return dataSyncManager.webClientId
  }

  async appendNotice(notice: AsyncOperationEvent): Promise<INoticeResult<AsyncOperationEventData>> {
    return dataSyncManager.appendAsyncOperationEvent(notice)
  }

  async removeNotice(id: string): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticeById(id)
  }

  async updateNoticeById(
    id: string,
    data: Partial<AsyncOperationEvent>
  ): Promise<INoticeResult<AsyncOperationEventData>> {
    return dataSyncManager.updateNoticeById<AsyncOperationEventData>(id, data)
  }

  // async getNoticeById(id: string): Promise<INoticeResult<AsyncOperationEventData>> {
  //   return dataSyncManager.getNoticeById(id)
  // }

  // async getAllNotices(): Promise<INoticeResult<AsyncOperationEventData[]>> {
  //   return dataSyncManager.getAllNoticesByCategory<AsyncOperationEventData>(NoticeCategory.EVENT)
  // }

  addNoticeListener(listener: INoticeListener<AsyncOperationEventData>) {
    dataSyncManager.addNoticeListener(NoticeCategory.EVENT, listener)
  }

  removeNoticeListener(listener: INoticeListener<AsyncOperationEventData>): boolean {
    return dataSyncManager.removeNoticeListener(NoticeCategory.EVENT, listener)
  }

  async removeNoticesByIds(ids: string[]): Promise<INoticeResult<boolean>> {
    return dataSyncManager.removeNoticesByIds(ids)
  }

  // async removeAllNotice(): Promise<INoticeResult<boolean>> {
  //   return dataSyncManager.removeNoticeByCategory<AsyncOperationEventData>(NoticeCategory.EVENT)
  // }
}
